function initialState() {
  return {
    accountPlanFeatures: null,
  };
}

let state = initialState();

export { initialState, state };
